import { render, staticRenderFns } from "./PublicUploads.vue?vue&type=template&id=5452d4fe"
import script from "./PublicUploads.vue?vue&type=script&lang=js"
export * from "./PublicUploads.vue?vue&type=script&lang=js"
import style0 from "./PublicUploads.vue?vue&type=style&index=0&id=5452d4fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports